<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR ' + tituloSingular.toUpperCase() : 'NOVO ' + tituloSingular.toUpperCase()" titleIcon="fas fa-edit">
            <div v-if="modoEdicao && !carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="16">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="120" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- Campos extras configuráveis pelo wrapper -->
                <el-row :gutter="10">
                    <el-col v-for="c in camposExtras" :key="c.campo" :xs="24" :sm="c.span || (camposExtras.length === 1 ? 24 : 12)">
                        <el-form-item :label="c.label">
                            <el-input v-if="c.tipo === 'text'" type="textarea" :rows="3" v-model="dados[c.campo]"></el-input>
                            <el-select v-else-if="c.tipo === 'boolean'" v-model="dados[c.campo]" style="width: 100%;">
                                <el-option :value="true" :label="c.labelAtivo || 'Sim'"></el-option>
                                <el-option :value="false" :label="c.labelInativo || 'Não'"></el-option>
                            </el-select>
                            <el-input v-mask="c.mask || '######'" v-else-if="c.tipo === 'int'" v-model="dados[c.campo]" :min="0" :step="1"></el-input>
                            <el-select v-else-if="c.tipo === 'select'" v-model="dados[c.campo]" filterable clearable style="width: 100%;" :placeholder="c.placeholder || 'Selecione'">
                                <el-option v-for="op in (opcoesRemotas[c.campo] || [])" :key="op[c.optionValue || 'id']" :label="op[c.optionLabel || 'nome']" :value="op[c.optionValue || 'id']"></el-option>
                            </el-select>
                            <el-input v-else v-model="dados[c.campo]" :maxlength="c.maxLength || 40"></el-input>
                            <div v-if="c.descricao" style="color: #909399; font-size: 12px;">{{ c.descricao }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link :to="rotaBase">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    props: {
        endpoint: { type: String, required: true },
        rotaBase: { type: String, required: true },
        tituloSingular: { type: String, required: true },
        camposExtras: { type: Array, default: () => [] }
    },
    data () {
        const base = { nome: '', situacao: true }
        this.camposExtras.forEach(c => {
            if (c.tipo === 'boolean') base[c.campo] = false
            else if (c.tipo === 'int') base[c.campo] = 0
            else if (c.tipo === 'select') base[c.campo] = null
            else base[c.campo] = ''
        })
        return { dados: base, modoEdicao: false, carregado: false, opcoesRemotas: {} }
    },
    mounted () {
        this.carregarOpcoesRemotas()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        carregarOpcoesRemotas () {
            this.camposExtras
                .filter(c => c.tipo === 'select' && c.optionsEndpoint)
                .forEach(c => {
                    this.$axios.get(
                        `${this.$store.state.config.baseUrlApi}/api/${c.optionsEndpoint}`,
                        this.$store.getters.getHeaderAuth
                    ).then(r => {
                        this.$set(this.opcoesRemotas, c.campo, r.data || [])
                    }).catch(e => this.$store.commit('throwException', e))
                })
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/${this.endpoint}/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                Object.keys(this.dados).forEach(k => {
                    if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k]
                })
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/${this.endpoint}/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/${this.endpoint}/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push(this.rotaBase)
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
